import BillService from "../services/Billservice";
import { nowDate } from "../components/Customs/nowDate";

// The billing system (bills, bill_items, split/merge/reports) is built
// entirely around `tables.id` — there's no separate "room" concept in it.
// To let a hotel room open/view bills with zero backend changes, each room
// gets a hidden backing row in the same `tables` table (is_active: 0, so it
// never shows up in the normal Tables & Bills grid), named uniquely per
// StayMaster room id. It's found-or-created lazily, only when a room's
// card is actually opened.
const roomTableName = (roomId) => `RoomSvc-${roomId}`;

export const findOrCreateRoomTable = async (roomId, capacity = 2) => {
  const name = roomTableName(roomId);

  const allTables = await BillService.getAllRaw("tables");
  const existing = (Array.isArray(allTables) ? allTables : []).find(
    (t) => t.name === name
  );

  if (existing) return existing;

  return BillService.createTable({
    name,
    capacity,
    is_active: 0,
    added_on: nowDate(),
    updated_on: nowDate(),
  });
};
